module.exports = __webpack_public_path__ + "img/KIENLONGBANK.a8106826.svg";